export default function fancyBox(){
    if(document.querySelector("[data-fancybox='gallery']")){
        Fancybox.bind("[data-fancybox='gallery']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='gallery-video']")){
        Fancybox.bind("[data-fancybox='gallery-video']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='residence']")){
        Fancybox.bind("[data-fancybox='residence']", {
            Thumbs: {
                type: "classic",
            },
        });
    }
}